import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
  OverlayContainerService,
  OverlayService
} from "@lantern/app/core/utils/overlays";

import { HoverableDirective } from "./hoverable.directive";

@NgModule({
  imports: [CommonModule],
  providers: [OverlayContainerService, OverlayService],
  declarations: [HoverableDirective],
  exports: [HoverableDirective]
})
export class HoverableModule {}
